// extracted by mini-css-extract-plugin
export default {"edit":"edit--mp-c_7Th","link":"link--mp-yeXQO"};